import { createRoute } from '@tanstack/react-router';
import { KategorieForm } from '@/modules/pujcovna/KategorieForm';
import { Route as RootRoute } from './__root';

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/platforma/pujcovna/kategorie/nova',
  component: KategorieForm,
});
